import styled from '@emotion/styled'
import colors from 'design-system/tokens/colors'
import ErrorBoundary from 'shared/components/ErrorBoundary'
import px from 'design-system/tokens/fontSizes'
import spacing from 'design-system/tokens/spacing'
import fontWeights from 'design-system/tokens/fontWeights'

import { DIMENSIONS } from '../LoggedIn/const'
import BaseCompanyLogo from './CompanyLogo'
import swoopLogo from '../images/swoop_logo.svg'

const HeaderComponent = styled.header`
  padding-left: 28px;
  background-color: ${colors.white};
  display: flex;
  gap: 28px;
  z-index: 1030;
  box-shadow:
    0 0 2px 0 rgba(141, 141, 148, 0.16),
    0 4px 8px -2px rgba(141, 141, 148, 0.28);

  @media screen and (max-width: ${DIMENSIONS.BREAKPOINT_HIDE_DROPNAV}) {
    padding-left: 5px;
  }
`

export const headerHeight = 60

const LogoContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  font-size: 0;
  height: ${headerHeight}px;
  line-height: ${headerHeight}px;
  justify-content: center;
  align-items: center;
`

const CompanyLogo = styled(BaseCompanyLogo)`
  align-items: center;
  display: inline-flex;
  padding: 0 28px;
`
const SwoopHeaderLogo = styled.i`
  height: 20px;
  width: 171px;
  display: initial;
  background: url(${swoopLogo});
`

const SkipToContent = styled.a`
  position: absolute;
  top: -95px;
  font-size: ${px.bodyLarge};
  left: ${spacing.xxs};
  padding: 0 ${spacing.xxs};
  background-color: ${colors.primary};
  font-weight: ${fontWeights.bold};
  border-radius: 4px;
  line-height: 2;

  &:focus {
    color: ${colors.white};
    top: ${spacing.xxs};
  }
`

export const mainContentId = 'main-content'

type HeaderProps = {
  useSwoopLogo?: boolean
  children?: React.ReactNode
}

const LogoOnlyHeader = ({ useSwoopLogo = false, children }: HeaderProps) => {
  return (
    <HeaderComponent data-testid="swoop-header">
      <ErrorBoundary>
        <SkipToContent href={`#${mainContentId}`}>Skip to Content</SkipToContent>
        <LogoContainer data-testid="swoop-logo">
          {useSwoopLogo ? <SwoopHeaderLogo aria-label="Swoop Logo" /> : <CompanyLogo />}
        </LogoContainer>
        {children}
      </ErrorBoundary>
    </HeaderComponent>
  )
}

export default LogoOnlyHeader
